import React from 'react'
import './experience.css'
import {FaCheckCircle} from 'react-icons/fa'
import {AiFillHtml5} from 'react-icons/ai'
import {FaCss3Alt} from 'react-icons/fa'
import {IoLogoJavascript} from 'react-icons/io'
import {RiReactjsLine} from 'react-icons/ri'
import {SiNextdotjs} from 'react-icons/si'
import {FaBootstrap} from 'react-icons/fa'
import {SiTailwindcss} from 'react-icons/si'
import {FaNodeJs} from 'react-icons/fa'
import {SiMysql} from 'react-icons/si'
import {DiMongodb} from 'react-icons/di'


const Experience = () => {
  return (
    <section id='experience'>
      <h5>What Skills I have</h5>
      <h2>My Experience</h2>

      <div className="container experience__container">
        <div className="experience__frontend">
        <h3>Front-End Development</h3>
        <div className="experience__content">
          <article className="experience__details">
            <AiFillHtml5 className="experience__details-icon" />
            <div>
            <h4>HTML</h4>
            <small className="text-light">Experienced</small>
            </div>
          </article>
          <article className="experience__details">
            <FaCss3Alt className="experience__details-icon" />
            <div>
            <h4>CSS</h4>
            <small className="text-light">Experienced</small>
            </div>
          </article>
          <article className="experience__details">
            <IoLogoJavascript className="experience__details-icon" />
            <div>
            <h4>JavaScript</h4>
            <small className="text-light">Intermediate</small>
            </div>
          </article>
          <article className="experience__details">
            <RiReactjsLine className="experience__details-icon" />
            <div>
            <h4>React.js</h4>
            <small className="text-light">Experienced</small>
            </div>
          </article>
          <article className="experience__details">
            <SiNextdotjs className="experience__details-icon" />
            <div>
            <h4>Next.js</h4>
            <small className="text-light">Intermediate</small>
            </div>
          </article>
          <article className="experience__details">
            <FaBootstrap className="experience__details-icon" />
            <div>
            <h4>BootStrap</h4>
            <small className="text-light">Experienced</small>
            </div>
          </article>
          <article className="experience__details">
            <SiTailwindcss className="experience__details-icon" />
            <div>
            <h4>Tailwind</h4>
            <small className="text-light">Intermediate</small>
            </div>
          </article>
        </div>
        </div>


        <div className="experience__backend">
        <h3>Back-End Development</h3>
        <div className="experience__content">
          <article className="experience__details">
            <FaNodeJs className="experience__details-icon" />
            <div>
            <h4>Node JS</h4>
            <small className="text-light">Intermediate</small>
            </div>
          </article>
          <article className="experience__details">
            <SiMysql className="experience__details-icon" />
            <div>
            <h4>MySQL</h4>
            <small className="text-light">Experienced</small>
            </div>
          </article>
          <article className="experience__details">
            <DiMongodb className="experience__details-icon" />
            <div>
            <h4>MongoDB</h4>
            <small className="text-light">Basic</small>
            </div>
          </article>
          
        </div>
        </div>
        </div>
    </section>
  )
}

export default Experience